// ═══════════════════════════════════════════════════════════════════════
// TELEMETRY ENGINE
// ═══════════════════════════════════════════════════════════════════════
// Captures user actions inside the deployed Agentic Operating System. This is the dataset
// that feeds the Phase 4 Evolution Engine. Without this, the Architect
// wouldn't know what features the user actually uses.
// ═══════════════════════════════════════════════════════════════════════

import { labData } from "./lab-data";

export type EventType =
  | "screen_view"
  | "screen_row_opened"
  | "architect_chat_opened"
  | "architect_message_sent"
  | "data_created"
  | "data_updated"
  | "pwa_installed";

interface TrackingPayload {
  event_type: EventType;
  screen_id?: string;
  metadata?: Record<string, any>;
}

export async function trackEvent(workspaceId: string, payload: TrackingPayload) {
  try {
    // We log the event asynchronously and silently. user_id stays null: it
    // always was (the browser never held a session — the old getSession()
    // answered null), and the os_events insert policy is written for that shape.
    // The request carries the viewer's SloeData token (role authenticated).
    labData.from("os_events").insert({
      os_id: workspaceId,
      user_id: null,
      event_type: payload.event_type,
      screen_id: payload.screen_id,
      metadata: payload.metadata || {}
    }).then(({ error }: { error: unknown }) => {
      if (error) console.error("[Telemetry Error]:", error);
    });
  } catch (err) {
    // Fail silently, telemetry should never break the app
  }
}
